import {
	ApiOutlined,
	CompassOutlined,
	CustomerServiceOutlined,
	SafetyCertificateOutlined,
	SoundOutlined,
	ThunderboltOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import FeatureCard from "./FeatureCard";

const featuresData = [
	{
		icon: SoundOutlined,
		title: "Professional 432 Hz Audio",
		description:
			"Original wellness compositions, professionally mastered at 432 Hz with consistent volume for a seamless listening experience.",
	},
	{
		icon: CompassOutlined,
		title: "30+ Wellness Genres",
		description:
			"A curated library spanning relaxation, mindfulness, meditation, spa, yoga, stress reduction, and holistic wellbeing.",
	},
	{
		icon: ThunderboltOutlined,
		title: "Plug & Play Setup",
		description:
			"Connect any Wi-Fi tablet or phone to your Bluetooth or wired speakers and stream instantly — no technical expertise required.",
	},
	{
		icon: ApiOutlined,
		title: "Multiple Music Zones",
		description:
			"Run different playlists across reception, treatment rooms, lounges, yoga studios, and guest suites — all from one platform.",
	},
	{
		icon: SafetyCertificateOutlined,
		title: "Secure & Reliable",
		description:
			"Cloud-based streaming with secure access and stable performance — uninterrupted music delivery throughout your business.",
	},
	{
		icon: CustomerServiceOutlined,
		title: "Dedicated Support",
		description:
			"Expert technical support is available whenever you need it, ensuring your music system runs smoothly and reliably.",
	},
];

const Features = () => {
	return (
		<Row gutter={[24, 24]} justify="center">
			{featuresData.map((feature) => (
				<Col xs={24} sm={12} md={8} key={feature.title}>
					<FeatureCard {...feature} />
				</Col>
			))}
		</Row>
	);
};

export default Features;
